<style scoped>
.ivu-avatar-large.ivu-avatar-icon {
  border-radius: 0;
}

.feed-container {
  display: flex;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #eee;
  align-items: center;
}

.feed-avatar {
  margin-right: 10px;
}

.feed-body {
  overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.feed-content > h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feed-content {
  overflow: hidden;
  margin-right: 30px;
}
</style>

<template>
    <div class="feed-list-view" style="position:relative">
        <div class="feed-container">
            <div class="feed-avatar" v-on:click="onTriggerAvatar">
                <Avatar v-if="avatar=='directory'" shape="square" icon="earth" style="width:80px;height:80px" size="large"/>
                <Avatar v-if="avatar!='directory'" shape="square" icon="person" style="width:80px;height:80px; border-radius: 100%" size="large" :src="avatarHandler(avatar)"/>
            </div>
            <div class="feed-body">
                <div class="feed-content">
                  <slot name="add-option"></slot>
                  <h3 v-on:click="onTriggerAvatar">{{title}}</h3>
                  <small v-if="item.careplan && !item.careplan.is_approved && item.careplan.type == 'alliance'" style="color:#ec2d2d">
                    Pending
                  </small>
                  <small style="color: #999">
                      <timeago v-if="subInfo" :since="subInfo"></timeago>
                      <p v-if="subInfo && poster">&middot;</p>
                      <b v-if="poster"> {{toTitleCase(poster)}}</b>
                  </small>
                </div>
                <!-- <Icon type="chevron-right"></Icon> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FeedListView',
  props: {
    avatar: {
      type: [String, Array],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subInfo: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    item: {
      type: Object
    }
  },
  methods: {
    avatarHandler (data) {
      if (Array.isArray(data)) {
        return data[0].small
      } else if (typeof data === 'string') {
        return data
      }
    },
    onTriggerAvatar () {
      this.$emit('emitContainer')
    },
    toTitleCase(str) {
      if(str == 'public'){
        str = 'group'
      }else if (str == 'interest'){
        str = 'advocacy'
      }else if (str == 'report_concern' || str == 'suggestion_box'){
        str = 'system'
      }
      return str.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
}
</script>
